
export default {
  name: 'HorizontalBanners',
  props: {
    advertisings: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getImage(advertising) {
      const image = advertising.advertisingType.cptAdv.cptAdvImageHorizontal
      return image
    },
  },
}
